// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"styles_primaryButton__3Q4Px"};